import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { EmailsService } from "../../_services/emails.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

declare var $: any;

@Component({
  selector: 'app-addemails',
  templateUrl: './addemails.component.html',
  styleUrls: ['./addemails.component.css']
})

export class AddemailsComponent implements OnInit {

  addEmailForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  emailTypeList: any[] = [];

  type = this.route.snapshot.params.type;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private emailsservice: EmailsService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    this.getAllEmailType();
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

      $('#mail_body').summernote({height: 250});


      if(this.type !== undefined){
          const payload = {
            mail_type: this.type
          };
        this.getEmailByType(payload)
      }else{
        $("#mail_body").summernote("code", "");
      }

    this.addEmailForm = this.formBuilder.group({
      mail_subject: ['', [Validators.required, Validators.minLength(3)]],
      mail_body: ['', [Validators.required]],
      mail_type: ['', [Validators.required]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  get f() { return this.addEmailForm.controls; }

  onSubmit() {
    let textareaValueEmpty: boolean;
    let messageData = $('#mail_body').summernote('code');
    //console.log(textareaValueEmpty);
    if (messageData == '' || messageData == "<p><br></p>"){
      textareaValueEmpty = false;
    }else{
      textareaValueEmpty = true;
    }
    //console.log(textareaValueEmpty);
    if (textareaValueEmpty == true){
      this.addEmailForm.controls.mail_body.setErrors(null);
      this.addEmailForm.controls.mail_body.setValue(messageData);
    }else{
      this.addEmailForm.controls.mail_body.setErrors({'required': true});
      this.addEmailForm.controls.mail_body.setValue('');
    }
    this.submitted = true;
    this.spinnerService.show();
   // console.log(textareaValue);
    // stop here if form is invalid
    if (this.addEmailForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      mail_subject: this.addEmailForm.controls.mail_subject.value,
      mail_body: this.addEmailForm.controls.mail_body.value,
      mail_type: this.addEmailForm.controls.mail_type.value
    };
   // console.log(addPayload);
    if(this.type == undefined){
      this.addEmail(addPayload);
    }else{
      this.editEmail(addPayload);
    }


  }

  addEmail(payload) {
    this.emailsservice.addEmail(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/get-emails']);
          } else {
            this.toaster.showError('Add Emails', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Emails', error.error.ResponseMessage);
        });
  }

  editEmail(payload) {
    this.emailsservice.editEmailByType(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/get-emails']);
          } else {
            this.toaster.showError('Add Emails', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Emails', error.error.ResponseMessage);
        });
  }

  getEmailByType(payload) {
    this.emailsservice.getEmailByType(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.addEmailForm.controls.mail_subject.setValue(data.emailList[0]['mail_subject']);
            this.addEmailForm.controls.mail_body.setValue(data.emailList[0]['mail_body']);
            this.addEmailForm.controls.mail_type.setValue(data.emailList[0]['mail_type']);
            $("#mail_body").summernote("code", data.emailList[0]['mail_body']);
          } else {
            console.log('Add Emails', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Emails', error);
        });
  }

  getAllEmailType() {
    this.emailsservice.getAllEmailType()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.emailTypeList = data.emailList;
          } else {
            console.log('Add Emails', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Add Emails', error);
        });
  }


}
